exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slidecontainer {\n    width: 100%;\n}\n.slider {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 25px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    transition: opacity .2s;\n}\n.slider:hover {\n    opacity: 1;\n}\n.slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 25px;\n    height: 25px;\n    background: #04AA6D;\n    cursor: pointer;\n}\n.slider::-moz-range-thumb {\n    width: 25px;\n    height: 25px;\n    background: #04AA6D;\n    cursor: pointer;\n}\n", ""]);

// exports
